'use client';

import { useRouter } from 'next/navigation';
import { useLocalHref } from '../navigation/base-path';

interface NoCreditsSheetProps {
  isOpen: boolean;
  onClose: () => void;
}

export function NoCreditsSheet({ isOpen, onClose }: NoCreditsSheetProps) {
  const router = useRouter();
  const creditsHref = useLocalHref('/credits');

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[110]">
      <div
        className="absolute inset-0 animate-in fade-in bg-[#060606]/50 duration-200"
        onClick={onClose}
      />
      <div className="absolute inset-x-0 bottom-0 animate-in slide-in-from-bottom duration-300">
        <div
          className="overflow-hidden rounded-t-[22px]"
          style={{
            background: '#242424',
            backdropFilter: 'blur(39px)',
            WebkitBackdropFilter: 'blur(39px)',
            border: '1px solid rgba(255,255,255,0.05)',
          }}
        >
          <div className="flex flex-col items-center px-[22px] pb-[21px] pt-[13px]">
            <div className="mb-2 flex w-full justify-end">
              <button
                onClick={onClose}
                className="flex h-9 w-9 items-center justify-center rounded-full bg-white/20"
              >
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round">
                  <line x1="1" y1="1" x2="13" y2="13" />
                  <line x1="13" y1="1" x2="1" y2="13" />
                </svg>
              </button>
            </div>

            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src="/assets/logo-full.svg"
              alt=""
              className="mb-10 h-auto w-24"
              style={{ filter: 'brightness(0) saturate(100%) invert(72%) sepia(15%) saturate(747%) hue-rotate(163deg) brightness(93%) contrast(87%)' }}
            />

            <h3 className="mb-2 text-center font-benzin text-xl font-semibold text-white">
              У вас недостаточно кредитов...
            </h3>
            <p className="mb-8 text-center text-base text-[#fafafa]">
              Пополните баланс, чтобы продолжить генерацию!
            </p>

            <button
              onClick={() => {
                onClose();
                router.push(creditsHref);
              }}
              className="flex h-[60px] w-full items-center justify-center rounded-full bg-accent text-base font-semibold text-white"
            >
              Пополнить
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
